import { cities, statesByCity } from '../../constants/Address';

export interface GuestAddress {
  city: string;
  state: string;
  zip?: string;
  address: string;
  taxNumber?: string;
  taxOffice?: string;
  addressType: number;
}

export const guestAddressOutputTransformer = (guestAddress: GuestAddress) => ({
  city: guestAddress.city,
  state: guestAddress.state,
  zip: guestAddress.zip,
  address_1: guestAddress.address,
  vergi_no: guestAddress.taxNumber,
  vergi_dairesi: guestAddress.taxOffice,
  address_type: guestAddress.addressType,
});

export const getEmptyGuestAddress = (): GuestAddress => ({
  city: cities[0],
  state: statesByCity[cities[0]][0],
  address: '',
  addressType: 0,
});
